(() => {
  if (typeof window === "undefined") {
    return;
  }

  const currentUrl = new URL(window.location.href);

  if (!currentUrl.searchParams.has("_fsv")) {
    return;
  }

  const links = document.querySelectorAll("a[href]");
  const currentDomain = window.location.hostname;
  const queryKeys = ["_fds", "_ftv", "_fsv"];
  links.forEach((link) => {
    try {
      const url = new URL(link.href);
      if (url.hostname !== currentDomain) {
        return;
      }
      queryKeys.forEach((queryKey) => {
        if (
          !currentUrl.searchParams.has(queryKey) ||
          url.searchParams.has(queryKey)
        ) {
          return;
        }
        url.searchParams.set(queryKey, currentUrl.searchParams.get(queryKey));
      });
      link.href = url.toString();
    } catch (e) {}
  });

  const data = new URLSearchParams();
  data.append("method", "site_view");
  data.append("action", "foenix_ai_settings");
  data.append("location_href", location.href);
  data.append("nonce", ajax_var.nonce);
  fetch(ajax_var.ajaxurl, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: data,
  });
})();
